export const UNPUBLISHED = "Unpublished";
export const AWAITING_APPROVAL = "AwaitingApproval";
export const PUBLISHED = "Published";
export const UPDATES_REQUIRED = "UpdatesRequired";
